import { LuBan, LuCircleArrowDown, LuCircleArrowUp, LuCircleCheckBig } from 'react-icons/lu';

export const PUDO_ICONS = {
    DROP_OFF: LuCircleArrowDown,
    PICK_UP: LuCircleArrowUp,
    CANCEL: LuBan,
    COMPLETE: LuCircleCheckBig
};
